import { useContext } from "react";

import CategoryPreview from "../../components/category-preview/category-preview.component";

import { CategoriesContext } from "../../contexts/categories.context";

const CategoriesPreview = () => {
  const { categoriesMap } = useContext(CategoriesContext);

  return (
    <div className='preview'>
      {Object.keys(categoriesMap).map(key => (
        <CategoryPreview key={key} title={key} products={categoriesMap[key]} />
      ))}
    </div>
  );
};

export default CategoriesPreview;